import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Map, SlidersHorizontal, ShieldCheck, Star, Clock, MapPin } from 'lucide-react';
import { professionals } from '../data/mockData';
export function SearchScreen() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('Doctors');
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const tabs = ['Doctors', 'Nurses', 'Caregivers', 'Clinics', 'Lab Tests'];
  const filteredProfessionals = professionals.filter(p => {
    if (activeTab === 'Doctors' && !p.specialty.toLowerCase().includes('doctor') && !p.specialty.toLowerCase().includes('pediatric') && !p.specialty.toLowerCase().includes('cardio')) return false;
    if (activeTab === 'Nurses' && !p.specialty.toLowerCase().includes('nurse') && !p.specialty.toLowerCase().includes('maternal')) return false;
    if (searchQuery) {
      return p.name.toLowerCase().includes(searchQuery.toLowerCase()) || p.specialty.toLowerCase().includes(searchQuery.toLowerCase());
    }
    return true;
  });
  return <div className="min-h-screen bg-ui-card flex flex-col" data-id="element-1571">
      {/* Header & Search */}
      <div className="bg-white pt-12 pb-4 px-6 shadow-sm z-10 sticky top-0" data-id="element-1572">
        <div className="flex items-center space-x-3 mb-4" data-id="element-1573">
          <div className="flex-1 relative" data-id="element-1574">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-1575">
              <Search size={18} className="text-text-secondary" data-id="element-1576" />
            </div>
            <input type="text" placeholder="Search symptoms, doctors..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-3 bg-ui-card border border-ui-border rounded-xl focus:ring-2 focus:ring-brand-primary outline-none text-sm" data-id="element-1577" />
          </div>
          <button onClick={() => setShowFilters(true)} className="w-12 h-12 bg-ui-card border border-ui-border rounded-xl flex items-center justify-center active:bg-gray-100" data-id="element-1578">
            <SlidersHorizontal size={20} className="text-text-main" data-id="element-1579" />
          </button>
        </div>

        {/* Tabs */}
        <div className="flex overflow-x-auto no-scrollbar space-x-2 pb-1" data-id="element-1580">
          {tabs.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors ${activeTab === tab ? 'bg-brand-primary text-white shadow-sm' : 'bg-ui-card text-text-secondary border border-ui-border'}`} data-id="element-1581">
              {tab}
            </button>)}
        </div>
      </div>

      {/* Results List */}
      <div className="flex-1 px-6 py-4 space-y-4" data-id="element-1582">
        <div className="flex justify-between items-center mb-2" data-id="element-1583">
          <span className="text-sm font-medium text-text-secondary" data-id="element-1584">
            {filteredProfessionals.length} results found
          </span>
          <button className="flex items-center text-sm font-medium text-brand-primary bg-brand-light px-3 py-1.5 rounded-lg" data-id="element-1585">
            <Map size={16} className="mr-1.5" data-id="element-1586" /> Map View
          </button>
        </div>

        {filteredProfessionals.map(prof => <div key={prof.id} onClick={() => navigate(`/profile/${prof.id}`)} className="bg-white rounded-2xl p-4 shadow-card border border-ui-border active:scale-[0.98] transition-transform" data-id="element-1587">
            <div className="flex space-x-4" data-id="element-1588">
              <img src={prof.image} alt={prof.name} className="w-20 h-20 rounded-xl object-cover" data-id="element-1589" />
              <div className="flex-1" data-id="element-1590">
                <div className="flex justify-between items-start" data-id="element-1591">
                  <div data-id="element-1592">
                    <div className="flex items-center" data-id="element-1593">
                      <h3 className="font-bold text-text-main text-base" data-id="element-1594">
                        {prof.name}
                      </h3>
                      {prof.verified && <ShieldCheck size={16} className="text-brand-primary ml-1" data-id="element-1595" />}
                    </div>
                    <p className="text-sm text-text-secondary" data-id="element-1596">
                      {prof.specialty}
                    </p>
                  </div>
                </div>

                <div className="flex items-center mt-2 space-x-3" data-id="element-1597">
                  <div className="flex items-center" data-id="element-1598">
                    <Star size={14} className="text-status-warning fill-current" data-id="element-1599" />
                    <span className="text-xs font-medium ml-1" data-id="element-1600">
                      {prof.rating}
                    </span>
                  </div>
                  <div className="flex items-center text-text-secondary" data-id="element-1601">
                    <MapPin size={14} className="mr-1" data-id="element-1602" />
                    <span className="text-xs" data-id="element-1603">{prof.distance}</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-4 pt-4 border-t border-ui-border flex items-center justify-between" data-id="element-1604">
              <div className="flex flex-col" data-id="element-1605">
                <span className="text-xs text-text-secondary mb-1 flex items-center" data-id="element-1606">
                  <Clock size={12} className="mr-1" data-id="element-1607" /> Next available
                </span>
                <span className="text-sm font-medium text-text-main" data-id="element-1608">
                  {prof.nextAvailable}
                </span>
              </div>
              <div className="flex flex-col items-end" data-id="element-1609">
                <span className="text-xs text-text-secondary mb-1" data-id="element-1610">
                  Consultation fee
                </span>
                <span className="text-sm font-bold text-brand-primary" data-id="element-1611">
                  ₦{prof.fee.toLocaleString()}
                </span>
              </div>
            </div>
          </div>)}
      </div>

      {/* Filters Bottom Sheet (Simplified for prototype) */}
      {showFilters && <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50" data-id="element-1612">
          <div className="bg-white w-full max-w-[430px] rounded-t-3xl p-6 pb-safe animate-slide-up" data-id="element-1613">
            <div className="flex justify-between items-center mb-6" data-id="element-1614">
              <h2 className="text-xl font-bold" data-id="element-1615">Filters</h2>
              <button onClick={() => setShowFilters(false)} className="text-text-secondary" data-id="element-1616">
                Close
              </button>
            </div>

            <div className="space-y-6" data-id="element-1617">
              <div data-id="element-1618">
                <h3 className="font-medium mb-3" data-id="element-1619">Consultation Mode</h3>
                <div className="flex flex-wrap gap-2" data-id="element-1620">
                  {['Any', 'Clinic Visit', 'Home Visit', 'Video Consult'].map(mode => <button key={mode} className={`px-4 py-2 rounded-full text-sm border ${mode === 'Any' ? 'bg-brand-primary text-white border-brand-primary' : 'border-ui-border text-text-main'}`} data-id="element-1621">
                        {mode}
                      </button>)}
                </div>
              </div>

              <div data-id="element-1622">
                <h3 className="font-medium mb-3" data-id="element-1623">Sort By</h3>
                <div className="grid grid-cols-2 gap-2" data-id="element-1624">
                  {['Nearest', 'Top Rated', 'Fastest Available', 'Lowest Fee'].map(sort => <button key={sort} className={`p-3 rounded-xl text-sm border text-left ${sort === 'Nearest' ? 'border-brand-primary bg-brand-light text-brand-primary font-medium' : 'border-ui-border text-text-main'}`} data-id="element-1625">
                      {sort}
                    </button>)}
                </div>
              </div>
            </div>

            <div className="mt-8 flex space-x-3" data-id="element-1626">
              <button className="flex-1 py-4 border border-ui-border rounded-xl font-medium" data-id="element-1627">
                Reset
              </button>
              <button onClick={() => setShowFilters(false)} className="flex-[2] py-4 bg-brand-primary text-white rounded-xl font-semibold shadow-md" data-id="element-1628">
                Apply Filters
              </button>
            </div>
          </div>
        </div>}
    </div>;
}